import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EmpresaService {
  private storageKey = 'idEmpresa';

  constructor() {}

  get idEmpresa() {
    const idEmpresa = Number(localStorage.getItem(this.storageKey));
    return idEmpresa;
  }

  setIdEmpresa(idEmpresa: number) {
    localStorage.setItem(this.storageKey, idEmpresa.toString());
  }

  clearidEmpresa(): void {
    localStorage.removeItem(this.storageKey);
  }
}
